import React, { useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import ModalHouseCommon from 'src/components/house/ModalHouseCommon'
import ModalPaymentRankUp from 'src/components/house/ModalPaymentRankUp'
import ShineOverlay from 'src/components/house/ShineOverlay'
import DiamondRed from 'src/assets/img/common/diamond-red.png'
import ChickenIcon from 'src/assets/img/house/mascot_01 1.svg'
import ButtonBuy from 'src/assets/img/house/btn_buy 1.svg'
import {
  RANK_UP_PRICE,
  RANK_ORDER,
  RANK_IMAGES,
  RANK_CONFIGS
} from 'src/pages/main/house/const/houseConstants'

const RankIcon = ({ rank }) => (
  <div className="w-6 h-6 xs:w-8 xs:h-8 rounded-full flex items-center justify-center">
    <img src={RANK_IMAGES[rank]} alt={rank} className="object-contain" />
  </div>
)

RankIcon.propTypes = {
  rank: PropTypes.string.isRequired
}

const RankPurchaseSection = ({ isNextRank, onPurchase }) => {
  if (!isNextRank) return null

  return (
    <div className="flex gap-1 items-center justify-between mt-2 pt-2">
      <div className="flex items-center gap-1 bg-[#9C9C9C] rounded">
        <div className="p-1 flex items-center gap-1">
          <img src={DiamondRed} alt="Diamond" className="w-4 h-4" />
          <span className="xs:text-xs font-medium text-[#F7F6EF]">ランクアップ必要数</span>
        </div>
        <p className="bg-white h-7 flex items-center px-1 text-xs rounded-r font-medium text-[#9C9C9C]">
          <span className="text-house-pink xs:text-base font-semibold tracking-wider">
            {RANK_UP_PRICE}
          </span>
          個
        </p>
      </div>
      <button
        onClick={onPurchase}
        className="max-w-[60px] cursor-pointer hover:opacity-80 transition-opacity"
      >
        <img src={ButtonBuy} alt="購入する" className="object-contain" />
      </button>
    </div>
  )
}

RankPurchaseSection.propTypes = {
  isNextRank: PropTypes.bool.isRequired,
  onPurchase: PropTypes.func.isRequired
}

const RankCard = ({ config, getRankStatus, onPurchase }) => {
  const { isCurrentRank, isAcquired, isHigherRank, isNextRank } = getRankStatus(config.rank)
  const showPurchaseButton = !isAcquired && isHigherRank

  return (
    <div key={config.rank} className="relative rounded-lg">
      <div className="flex items-center justify-between mb-1 gap-1">
        <RankIcon rank={config.rank} />

        <div className="text-[9px] xs:text-xs leading-tight font-semibold tracking-wider text-[#062E3E] uppercase">
          {config.rank}
        </div>

        <div className="p-0.5 bg-[#38C2D3] text-[7px] xs:text-[8px] font-semibold text-white rounded tracking-wider">
          マス目
        </div>

        <div className="text-[8px] xs:text-[10px] font-medium text-[#062E3E]">
          {config.gridSize}
        </div>

        <div
          className={`px-1 xs:px-2 py-1 rounded-full text-[8px] font-bold bg-[#333333] ${
            isCurrentRank || isAcquired ? 'text-white' : 'text-house-pink'
          }`}
        >
          {isAcquired ? '獲得済み！' : '未獲得！'}
        </div>
      </div>

      <div
        className={`relative overflow-x-hidden p-1.5 rounded text-[7px] xs:text-[9px] mb-2 whitespace-pre font-medium text-[#062E3E] tracking-wider ${
          isCurrentRank || isAcquired ? 'bg-[#33333380]' : 'bg-[#D1D1D1]'
        }`}
      >
        {isHigherRank && <ShineOverlay />}

        {config.description}
        {showPurchaseButton && (
          <RankPurchaseSection isNextRank={isNextRank} onPurchase={onPurchase} />
        )}
      </div>
    </div>
  )
}

RankCard.propTypes = {
  config: PropTypes.shape({
    rank: PropTypes.string.isRequired,
    gridSize: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  }).isRequired,
  getRankStatus: PropTypes.func.isRequired,
  onPurchase: PropTypes.func.isRequired
}

const ModalRankUp = ({ open, onClose, userId, userRank, userRedAmount }) => {
  const [openModalUpRank, setOpenModalUpRank] = useState(false)

  const currentRankIndex = useMemo(() => RANK_ORDER.indexOf(userRank), [userRank])
  const nextRankIndex = useMemo(() => currentRankIndex + 1, [currentRankIndex])

  const handlePurchase = () => {
    setOpenModalUpRank(true)
  }

  const getRankStatus = (configRank) => {
    const configRankIndex = RANK_ORDER.indexOf(configRank)
    return {
      isCurrentRank: userRank === configRank,
      isAcquired: configRankIndex <= currentRankIndex,
      isHigherRank: configRankIndex > currentRankIndex,
      isNextRank: configRankIndex === nextRankIndex
    }
  }

  return (
    <>
      <ModalHouseCommon
        open={open}
        onClose={onClose}
        height="max-h-[90%] max-w-[90%] xs:max-w-[350px]"
      >
        <div className="w-full flex flex-col font-ShinMaruGo overflow-y-auto hidden-scroll">
          <div className="sticky top-0 z-20 flex w-full gap-2 border-b-[3px] rounded-tl-3xl border-house-pink bg-cream">
            <div className="max-w-1/3 py-2 rounded-tl-[16px] bg-house-pink bg-pat01">
              <span className="pl-4 pr-8 text-white text-xl tracking-wider font-semibold">
                RANK UP
              </span>
            </div>
          </div>

          <div className="bg-pat02 space-y-3 py-3">
            <div className="relative mx-auto w-[90%] flex items-center gap-3 p-3 rounded-[10px] bg-cream-gray bg-pat01 border-[3px] border-stone-gray">
              <div className="text-[8px] xs:text-[11px] font-semibold tracking-wider text-[#062E3E]">
                現在のRANK: <span className="uppercase">{userRank}</span>
              </div>
              <img
                src={ChickenIcon}
                alt="Chicken"
                className="absolute bottom-0 right-[-20px] h-12 xs:h-14 object-contain"
              />
            </div>

            <div className="w-[90%] p-2 overflow-y-auto mx-auto bg-[#F1DCC3] bg-pat01 border-stone-gray border-2 rounded-xl">
              <div className="flex flex-col overflow-auto max-h-[400px] scrollbar-custom pr-2">
                {RANK_CONFIGS.map((config) => (
                  <RankCard
                    key={config.rank}
                    config={config}
                    getRankStatus={getRankStatus}
                    onPurchase={handlePurchase}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </ModalHouseCommon>

      <ModalPaymentRankUp
        open={openModalUpRank}
        setOpenModalUpRank={setOpenModalUpRank}
        userId={userId}
        userRank={userRank}
        userRedAmount={userRedAmount}
        onCloseModal={onClose}
      />
    </>
  )
}

ModalRankUp.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  userId: PropTypes.number,
  userRank: PropTypes.string,
  userRedAmount: PropTypes.number
}

export default ModalRankUp
